import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./Inner_Stay_Card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

function Inner_Stay_Card({
  item,
  icons,
  // mainImage,
  // changeMainImage,
  // index,
  // hideImages = false,
  staticData,
}) {
  const [activeMeal, setActiveMeal] = useState("breakfast");

  return (
    <div className="itinerary_card Inner_Summary_Card">
      <div className="day_card">
        <div className="section_box">
          <div className="section_title">
            <img src={icons?.bed} className="icon_img" alt="" />
            Stay at
          </div>
          <div className="hotel_name">
            Stay at {item?.hotel}
            <span className="hotel_rating"></span>
          </div>
          <div className="check_row">
            <span>
              Check In <b>{item?.check_in}</b>
            </span>
            <span>
              Check Out <b>{item?.check_out}</b>
            </span>
          </div>
        </div>

        <div className="">
          <Swiper
            spaceBetween={10}
            breakpoints={{
              0: { slidesPerView: 4 },
              576: { slidesPerView: 6 },
              768: { slidesPerView: 5 },
              992: { slidesPerView: 6 },
              1024: { slidesPerView: 2 },
            }}
          >
            {staticData?.map((item, i) => (
              <SwiperSlide key={i}>
                <div className="hotel_card">
                  <div className="hotel_img_holder">
                    <img src={item?.img} className="hotelImg" alt="" />
                    <p className="rating_text">
                      <FontAwesomeIcon icon={faStar} className="icon" />
                      {item?.rating}
                    </p>
                  </div>
                  <p className="hotel_name">{item?.hotelName}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {!staticData && (
            <div className="inclusion_wrapper">
              <div className="inclusion_card">
                <div className="inclusion_left">
                  <h6>Standard</h6>
                  <p>Inclusions:</p>
                </div>

                <div className="inclusion_items">
                  <div
                    className={`inclusion_item ${
                      activeMeal === "breakfast" ? "active" : ""
                    }`}
                    onClick={() => setActiveMeal("breakfast")}
                  >
                    <div className="img_holder">
                      <img
                        src="/assets/images/icons/img1.png"
                        className="inner_img"
                      />
                    </div>
                    <p className="inner_text">Breakfast</p>
                    <span className="inner_text">Included</span>
                  </div>

                  <div className="inclusion_divider"></div>

                  <div
                    className={`inclusion_item ${
                      activeMeal === "lunch" ? "active" : ""
                    }`}
                    onClick={() => setActiveMeal("lunch")}
                  >
                    <div className="img_holder">
                      <img
                        src="/assets/images/icons/img2.png"
                        className="inner_img"
                      />
                    </div>
                    <p className="inner_text">Lunch</p>
                    <span className="inner_text">Not Included</span>
                  </div>

                  <div className="inclusion_divider"></div>

                  <div
                    className={`inclusion_item ${
                      activeMeal === "dinner" ? "active" : ""
                    }`}
                    onClick={() => setActiveMeal("dinner")}
                  >
                    <div className="img_holder">
                      <img
                        src="/assets/images/icons/img3.png"
                        className="inner_img"
                      />
                    </div>
                    <p className="inner_text">Dinner</p>
                    <span className="inner_text">Not Included</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Inner_Stay_Card;
